const ANIMATION_TYPES = {
  NONE: 'NONE',
  IN: 'IN',
  OUT: 'OUT',
  IN_REVERSED: 'IN_REVERSED',
  OUT_REVERSED: 'OUT_REVERSED'
}

export default ANIMATION_TYPES



// WEBPACK FOOTER //
// ./src/constants/animationTypes.js